module.exports = __webpack_public_path__ + "static/media/B4.4daf1a3d.svg";